export enum ConditionOperator {
  equal = 'equal',
  notEqual = 'notEqual',
  greaterThan = 'greaterThan',
  greaterThanOrEqual = 'greaterThanOrEqual',
  lessThan = 'lessThan',
  lessThanOrEqual = 'lessThanOrEqual',
  contains = 'contains',
  notContains = 'notContains',
}
